module.exports = __webpack_public_path__ + "static/img/Tameka-Yallop.5b2892c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tameka-Yallop.jpg
// module id = MA1K
// module chunks = 0